import * as React from 'react';
import * as styles from './SidebarPrice.css';

interface ISidebarPriceProps {
  startPrice?: string;
  endPrice?: string;
  contactsButton: React.ReactNode;
  callbackButton?: React.ReactNode;
}

export const SidebarPrice: React.FC<ISidebarPriceProps> = ({
  startPrice,
  endPrice,
  contactsButton,
  callbackButton,
}) => {
  return (
    <div data-name="SidebarPrice" className={styles['container']}>
      <div className={styles['price']}>
        {startPrice} <br /> {endPrice}
      </div>
      <div className={styles['actions']}>
        {contactsButton}
        {callbackButton}
      </div>
    </div>
  );
};
